var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.imgComponent,{tag:"component",attrs:{"reportDetail":_vm.reportDetail},on:{"update:reportDetail":function($event){_vm.reportDetail=$event},"update:report-detail":function($event){_vm.reportDetail=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }